import type { ThumbnailRef } from '@pb/shared';

export function anyPending(refs: (ThumbnailRef | null | undefined)[]): boolean {
  return refs.some((ref) => ref?.status === 'pending');
}
